import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from "./services/auth-guard.service";



const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},

  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule),
  },

  {
    path: 'misreportes',
    loadChildren: () => import('./misreportes/misreportes.module').then( m => m.MisreportesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'kpi',
    loadChildren: () => import('./kpi/kpi.module').then( m => m.KPIPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then( m => m.SignupPageModule)
  },

  {
    path: 'modal-upload',
    loadChildren: () => import('./modal-upload/modal-upload.module').then( m => m.ModalUploadPageModule)
  },

  {
    path: 'mis-permisos',
    loadChildren: () => import('./mis-permisos/mis-permisos.module').then( m => m.MisPermisosPageModule)
  },
  {
    path: 'modal-crear-trabajador',
    loadChildren: () => import('./modal-crear-trabajador/modal-crear-trabajador.module').then( m => m.ModalCrearTrabajadorPageModule)
  },
  {
    path: 'modal-buscar-trabajador',
    loadChildren: () => import('./modal-buscar-trabajador/modal-buscar-trabajador.module').then( m => m.ModalBuscarTrabajadorPageModule)
  },
  {
    path: 'modal-editar-trabajador',
    loadChildren: () => import('./modal-editar-trabajador/modal-editar-trabajador.module').then( m => m.ModalEditarTrabajadorPageModule)
  },
  {
    path: 'modal-actividades-trabajador',
    loadChildren: () => import('./modal-actividades-trabajador/modal-actividades-trabajador.module').then( m => m.ModalActividadesTrabajadorPageModule)
  },

  {
    path: 'modal-herramientas-ycontroles',
    loadChildren: () => import('./modal-herramientas-ycontroles/modal-herramientas-ycontroles.module').then( m => m.ModalHerramientasYControlesPageModule)
  },

  {
    path: 'permisos-pendientes',
    loadChildren: () => import('./permisos-pendientes/permisos-pendientes.module').then( m => m.PermisosPendientesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'detalle',
    loadChildren: () => import('./detalle/detalle.module').then( m => m.DetallePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-aprobacion',
    loadChildren: () => import('./modal-aprobacion/modal-aprobacion.module').then( m => m.ModalAprobacionPageModule)
  },
  {
    path: 'resumen',
    loadChildren: () => import('./resumen/resumen.module').then( m => m.ResumenPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-logs-autoridades',
    loadChildren: () => import('./modal-logs-autoridades/modal-logs-autoridades.module').then( m => m.ModalLogsAutoridadesPageModule)
  },
  {
    path: 'modal-calificacion',
    loadChildren: () => import('./modal-calificacion/modal-calificacion.module').then( m => m.ModalCalificacionPageModule)
  },
  {
    path: 'modal-reasignar',
    loadChildren: () => import('./modal-reasignar/modal-reasignar.module').then( m => m.ModalReasignarPageModule)
  },
  {
    path: 'modal-asignacion-inicial',
    loadChildren: () => import('./modal-asignacion-inicial/modal-asignacion-inicial.module').then( m => m.ModalAsignacionInicialPageModule)
  },
  {
    path: 'modal-edicion-autoridades',
    loadChildren: () => import('./modal-edicion-autoridades/modal-edicion-autoridades.module').then( m => m.ModalEdicionAutoridadesPageModule)
  },
  {
    path: 'tabla-trabajadores-activos',
    loadChildren: () => import('./tabla-trabajadores-activos/tabla-trabajadores-activos.module').then( m => m.TablaTrabajadoresActivosPageModule)
  }


]; 

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
